import { WidgetConsumerPageContent } from 'components/www/WidgetConsumerPageContent';
import { useLocation } from 'react-router';
import React from 'react';

const CollectionPageRoute: React.FunctionComponent = () => {
  const location = useLocation();

  return <WidgetConsumerPageContent pathname={location.pathname} standAlone={false} />;
};

export default CollectionPageRoute;
